import React from 'react'
import Form from 'react-bootstrap/Form'

import General from '../../../../utils/General'

export default class Range extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: "i"+General.uuid(),
      value: props.value,
      min: props.min,
      max: props.max,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }
  _rangePercentage(input, range_min, range_max) {
    var percentage = ((input - range_min) * 100) / (range_max - range_min)
    if (percentage > 100) {
      percentage = 100
    } else if (percentage < 0) {
      percentage = 0
    }
    return percentage
  }

  render() {
    let { id } = this.state
    return (
      <div className="common range d-flex">
        <style
          dangerouslySetInnerHTML={{
            __html: `
              #${id}.form-range::-webkit-slider-runnable-track {
                  background-size: ${this._rangePercentage(
                    this.props.value,
                    this.props.min,
                    this.props.max
                  )}% 100%;
              }
            `,
          }}
        />
        <Form.Range
          {...this.props}
          id={id}
        />
      </div>
    )
  }
}
